<template>
  <div style="height: 400px;position: relative; z-index: 1">
    <l-map ref="map" :zoom="18" :center="center" :useGlobalLeaflet="false" :options="{ scrollWheelZoom: false }"
      @click="onMapClick" @update:zoom="zoom = $event" @update:center="center = $event" class="map-container">
      <!-- <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          layer-type="base"
          name="OpenStreetMap Basemap"
        ></l-tile-layer> -->
      <l-tile-layer url="https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}" layer-type="base"
        name="Stadia Maps Basemap" />

      <l-marker v-if="markerPosition" :lat-lng="[markerPosition.lat, markerPosition.lng]">
        <l-popup>
          Location: {{ markerPosition.lat }}, {{ markerPosition.lng }}
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  props: {
    initialZoom: {
      type: Number,
    },
    lat: {
      type: Number,
    },
    lng: {
      type: Number,
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Object,
      default: () => ({}),
    },
    tambon: {
      type: String,
      default: () => "",
    },
    amphur: {
      type: String,
      default: () => "",
    },
    province: {
      type: String,
      default: () => "",
    },
    location: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      zoom: this.initialZoom || 18,
      center: {
        lat:
          this.items && Object.keys(this.items).length !== 0
            ? this.items.lat
            : 13.7245449,
        lng:
          this.items && Object.keys(this.items).length !== 0
            ? this.items.lng
            : 100.4682975,
      },
      markerPosition: {
        lat:
          this.items && Object.keys(this.items).length !== 0
            ? this.items.lat
            : 13.7245449,
        lng:
          this.items && Object.keys(this.items).length !== 0
            ? this.items.lng
            : 100.4682975,
      },
      latitude: "",
      longitude: "",
    };
  },
  watch: {
    windowWidth() {
      this.$refs.map.mapObject.invalidateSize();
    },
    "items.lat"(newValue) {
      // console.log("🚀 ~ newValue:", newValue);
      if (newValue) {
        (this.center = {
          lat: this.items.lat || 13.7245449,
          lng: this.items.lng || 100.4682975,
        }),
          (this.markerPosition = {
            lat: this.items.lat || 13.7245449,
            lng: this.items.lng || 100.4682975,
          });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.map) {
        this.$refs.map.mapObject.invalidateSize();
      }
    });
  },
  methods: {
    // ฟังก์ชันเพื่อขอตำแหน่งปัจจุบันของผู้ใช้
    async getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.markerPosition = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.center = [this.latitude, this.longitude];
            this.$emit("place-name", {
              lat: this.latitude,
              lng: this.longitude,
              address: this.address,
            });
            this.zoom = 18;
          },
          (error) => {
            this.error = error.message;
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },
    // ฟังก์ชันเพื่อจับตำแหน่งที่ผู้ใช้เลือกเมื่อคลิก
    async onMapClick(event) {
      if (!this.draggable) return;
      this.markerPosition = {
        lat: event.latlng.lat,
        lng: event.latlng.lng,
      };
      this.latitude = this.markerPosition.lat;
      this.longitude = this.markerPosition.lng;
      this.center = [this.latitude, this.longitude];
      this.$emit("map-clicked", {
        lat: this.latitude,
        lng: this.longitude,
        address: this.address,
      });
      this.zoom = 18;
    },
  },
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.custom-text-field>>>input::placeholder {
  font-family: "TH SarabunPSK", "TH Sarabun New", "Angsana New", sans-serif;
  font-size: 22px;
  font-weight: 600;
  color: #767778;
}
</style>
